import { render, staticRenderFns } from "./InvestFormula.vue?vue&type=template&id=5e99d672&scoped=true"
import script from "./InvestFormula.vue?vue&type=script&lang=js"
export * from "./InvestFormula.vue?vue&type=script&lang=js"
import style0 from "./InvestFormula.vue?vue&type=style&index=0&id=5e99d672&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99d672",
  null
  
)

export default component.exports